<script lang="ts">
	import type { PageData } from './$types';
	import MetaBlock from '$lib/components/Storyblok/MetaBlock.svelte';
	import CommonDataPage from '$lib/components/CommonDataPage.svelte';

	export let data: PageData;
</script>

<MetaBlock
	content={data.story.content}
	defaults={{
		description: 'seo.description.agb',
		meta_keywords: 'seo.meta_keywords.agb',
		title: 'seo.title.agb'
	}}
/>
<CommonDataPage story={data.story} showSideMenu />
